export class RetainCampaignBuilder {
    constructor() {
        this.campaign = {};
    }

    setId(id){
        this.campaign.id = id;
        return this;
    }

    setName(name){
        this.campaign.name = name;
        return this;
    }

    setConversations(conversations){
        this.campaign.conversations = conversations;
        return this;
    }

    setWinbackRevenue(winbackRevenue) {
        this.campaign.winbackRevenue = winbackRevenue;
        return this;
    }

    setRevenuePerRecipient(revenuePerRecipient) {
        this.campaign.revenuePerRecipient = revenuePerRecipient;
        return this;
    }

    setAverageWinbackOrderValue(averageWinbackOrderValue) {
        this.campaign.averageWinbackOrderValue = averageWinbackOrderValue
        return this
    }

    setConversionRate(conversionRate) {
        this.campaign.conversionRate = conversionRate
        return this
    }

    setConversions(conversions) {
        this.campaign.conversions = conversions
        return this
    }

    setOrders(orders) {
        this.campaign.orders = orders
        return this
    }

    setAdditionalRevenue(additionalRevenue) {
        this.campaign.additionalRevenue = additionalRevenue;
        return this;
    }

    setLtvIncreaseRatio(ltvIncreaseRatio) {
        this.campaign.ltvIncreaseRatio = ltvIncreaseRatio;
        return this;
    }

    setAdditionalOrdersRate(additionalOrdersRate) {
        this.campaign.additionalOrdersRate = additionalOrdersRate;
        return this;
    }

    setActions(actions){
        this.campaign.actions = actions;
        return this;
    }

    setParam(param){
        this.campaign.param = param;
        return this;
    }

    build(){
        return this.campaign;
    }
}
